(function($, window, document, undefined) {
  'use strict';

  // init modr chop plugin
  modr.init('accordion', 'jquery', {
    chop: ['accordion', 'url'],
    helper: ['events'],
  });

  var VIEW = {
    mobile: 1,
    desktop: 2,
    desktopMinWidth: 768,
    viewMode: '',
  };

  var HEIGHT = {};

  var checkViewMode = function() {
    // adjust height for mobile OS bar
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');

    var vw = document.documentElement.clientWidth * 0.01;
    document.documentElement.style.setProperty('--vw', vw + 'px');

    var changed = false;
    var windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    // set current view mode
    if (windowWidth >= VIEW.desktopMinWidth && VIEW.viewMode !== VIEW.desktop) {
      VIEW.viewMode = VIEW.desktop;
      changed = true;
    } else if (
      windowWidth < VIEW.desktopMinWidth &&
      VIEW.viewMode !== VIEW.mobile
    ) {
      VIEW.viewMode = VIEW.mobile;
      changed = true;
    }
    return changed;
  };

  var setHeightWithPromoHeader = function() {
    var $header = $('.header');
    HEIGHT.headerMeta =
      $header.find('.header__meta').length > 0
        ? $header.find('.header__meta').css('display') !== 'none'
          ? $header.find('.header__meta').height()
          : 0
        : 0;
    HEIGHT.headerMain =
      $header.find('.header__main').length > 0
        ? $header.find('.header__main').css('display') !== 'none'
          ? $header.find('.header__main').height()
          : 0
        : 0;
    HEIGHT.headerLogo =
      $header.find('.header__logo').length > 0
        ? $header.find('.header__logo').css('display') !== 'none'
          ? $header.find('.header__logo').height()
          : 0
        : 0;
    HEIGHT.headerPromo =
      $header.find('.header__promo').length > 0
        ? $header.find('.header__promo').css('display') !== 'none'
          ? $header.find('.header__promo').height()
          : 0
        : 0;
    HEIGHT.headerBrowser =
      $header.find('.header__browserwarning').length > 0
        ? $header.find('.header__browserwarning').css('display') !== 'none'
          ? $header.find('.header__browserwarning').height()
          : 0
        : 0;
    HEIGHT.headerError =
      $header.find('.component.errormessage').length > 0
        ? $header.find('.component.errormessage').css('display') !== 'none'
          ? $header.find('.component.errormessage').height()
          : 0
        : 0;

    HEIGHT.header =
      HEIGHT.headerMeta +
      HEIGHT.headerMain +
      HEIGHT.headerPromo +
      HEIGHT.headerBrowser +
      HEIGHT.headerError;

    $('main').css('padding-top', HEIGHT.header + 'px');
  };

  var scrollToTarget = function(selector) {
    var isIE = global.configuration.get('global.IE');
    var timeout = 100;

    if (isIE) {
      timeout = 500;
    }

    var meta = $('.header__meta');
    var metaHeight = 0;
    if (meta.length) {
      metaHeight = meta.height();
    }

    var logo = $('.header__logo');
    var logoHeight = 0;
    if (logo.length) {
      logoHeight = logo.height();
    }

    var errorMessages = $('.component.errormessage');
    var errorMessagesHeight = 0;
    if (errorMessages.length) {
      errorMessagesHeight = errorMessages.height();
    }

    setTimeout(function() {
      reduceHeader();

      var yPos = $(selector).offset().top - 20;

      if (window.matchMedia('screen and (max-width: 767px)').matches) {
        // mobile with sticky header
        yPos -= logoHeight + errorMessagesHeight;
      } else if (window.matchMedia('screen and (min-width: 1024px)').matches) {
        // desktop with scrolled header
        yPos -= logoHeight + errorMessagesHeight;
      } else {
        // tablet with sticky header
        yPos -= metaHeight + logoHeight + errorMessagesHeight;
      }

      window.scroll({
        top: yPos,
      });
    }, timeout);
  };

  var reduceHeader = function() {
    if (!$('body').hasClass('is-fixed')) {
      if ($(window).scrollTop() > HEIGHT.headerMeta + HEIGHT.headerLogo) {
        $('.header').addClass('header--scrolled');
      } else {
        $('.header').removeClass('header--scrolled');
      }
    }
  };

  if (typeof window.Promise === 'undefined') {
    window.Promise = window.ES6Promise;
  }

  $(document).ready(function() {
    checkViewMode();

    $(window).on('resize', function() {
      checkViewMode();
    });

    // slim header on scroll
    $(window).on('scroll', function() {
      reduceHeader();
    });

    // init responsive image plugin, note: slider images are initialized on slider ready event
    $('.picture:not(.picture--slider)').responsiveImage({
      autoDpr: true,
      attributes: ['loading', 'title', 'alt', 'class', 'width', 'height'],
    });

    // promotion code cookie
    $('body').promotionCode();

    // Button page scroller
    var headerOffset = $('.header--sticky').height();

    $('button.scroller').on('click', function() {
      var $to = $(this).attr('data-scroll');
      window.scroll({
        top: $('#' + $to).offset().top - headerOffset,
        behavior: 'smooth',
      });
    });

    // init supernumber calculation for contact
    $('.contact__supernumber').supernumber();

    // init supernumber calculation for superNumber
    $('.superNumber__number').supernumber();

    // init magnific popups
    if ($('.js-magnify').length > 0) {
      $('.js-magnify').magnificPopup({
        type: 'image',
        showCloseBtn: false,
      });
    }

    // init swiper slider
    if (typeof $.fn.swiperSlider === 'function') {
      // init gallery BEFORE slider
      if (typeof $.fn.gallerySwiper === 'function') {
        $('.slider--gallery').gallerySwiper();
      }

      $('.slider').swiperSlider();

      $(window).trigger('resize');

      if (!Modernizr.objectfit && typeof $.fn.objectFit === 'function') {
        $('.slider .picture img').objectFit({
          container: '.figure',
        });
      }
    }

    // init swiper carousel
    if (typeof $.fn.carouselSwiper === 'function') {
      $('.carousel--swiper').carouselSwiper();
    }

    /*
		$(document).on('click', 'a.overline--back', function(e){
			var link = $.deparam(window.location.search.replace(/^\?/, ''));
			link = link.back;

			if(link) {
				e.preventDefault();
				history.go(-1);
			}
		});*/

    if (document.querySelector('.navigationCTA')) {
      var navigationCTAItems = document.querySelectorAll('.navigationCTA');
      for (var b = 0; b < navigationCTAItems.length; b++) {
        window.biotope.navigationCTA(navigationCTAItems[b]);
      }
    }

    if (document.querySelector('.popover')) {
      var popoverItems = document.querySelectorAll('.popover');
      for (var b = 0; b < popoverItems.length; b++) {
        window.biotope.popover(popoverItems[b], { desktopOnly: true });
      }
    }

    window.biotope.structuredData();

    if (document.querySelector('.viewport') !== null) {
      // check objectFit polyfill
      if (!Modernizr.objectfit && typeof $.fn.objectFit === 'function') {
        var triggerViewportObecjtFit = function() {
          $('.viewport__background img').objectFit({
            container: 'figure',
            minWidthBreakpoint: 0,
          });
        };

        // initial trigger
        triggerViewportObecjtFit();
        $(window).on('load resize reload.viewport', triggerViewportObecjtFit);
        $('.targetGroupFilter').on(
          'after.update.targetGroupFilter',
          triggerViewportObecjtFit
        );

        // trigger object fit for responsive images
        $('.viewport__background .picture img').objectFit({
          container: 'figure',
          minWidthBreakpoint: 0,
        });
      }
    }

    if ($('.header').css('visibility') === 'visible') {
      setHeightWithPromoHeader();
      $(window).on('resize load', function() {
        setHeightWithPromoHeader();
      });
    }

    if (
      document.querySelector(
        '.searchResults__item:target .searchResults__title'
      )
    ) {
      scrollToTarget('.searchResults__item:target .searchResults__title');
    }

    if (document.querySelector('.columns[data-anchor]:target')) {
      scrollToTarget('.columns[data-anchor]:target');
    }

    if (document.querySelector('.viewport[data-anchor]:target')) {
      scrollToTarget('.viewport[data-anchor]:target');
    }

    if (document.querySelector('.glossary__section-header:target')) {
      scrollToTarget('.glossary__section-header:target');
    }

    if (document.querySelector('.glossary__section-body dt:target')) {
      scrollToTarget('.glossary__section-body dt:target');
    }

    if ($('.glossary__nav-item > a[href*="#"]').length) {
      $('.glossary__nav-item > a[href*="#"]').on('click', function(evt) {
        document.documentElement.style.scrollBehavior = 'smooth';
        scrollToTarget(evt.currentTarget.getAttribute('href'), true);
        setTimeout(function() {
          document.documentElement.style.scrollBehavior = 'auto';
        }, 1000);
      });
    }

    $('a[href^="#"]').on('click', function(evt) {
      var href = evt.currentTarget.getAttribute('href');

      if (href.indexOf('#') === 0 && href.length > 1) {
        var $target = $(href);
        document.documentElement.style.scrollBehavior = 'smooth';
        scrollToTarget($target, true);
        setTimeout(function() {
          document.documentElement.style.scrollBehavior = 'auto';
        }, 1000);
      }
    });

    /* if (document.querySelector('.toolbar__content') !== null) {
			var toolbar = $('.toolbar__content');
			toolbar.find('h2').each(function () {
				var replaceText = $(this).text().replace(/\({1}(.*?)\){1}/g, "<span class='subheader'>($1)</span>");
				$(this).html(replaceText);
			});
			toolbar.find('time').each(function () {
				if (/Mo - Fr:/.test($(this).text())) {
					var replaceMoFr = $(this).text().replace(/Mo - Fr:/g, "<strong>Mo - Fr:</strong>");
					$(this).html(replaceMoFr);
				}
				if (/Sa:/.test($(this).text())) {
					var replaceSa = $(this).text().replace(/Sa:/g, "<strong>Sa:</strong>");
					$(this).html(replaceSa);
				}
			});
		} */

    // init errormessage
    if (typeof $.fn.errormessage === 'function') {
      $('.errormessage').each(function() {
        var data = $(this).data();
        $(this).errormessage({
          messagesUrl: data.messagesUrl,
          client: data.client,
          detailURL: data.detailUrl,
        });
      });
    }

    //init newslist
    $('.newsList').news({
      injectDataCallback: function(data) {
        data.detailUrl = this.$element.data('detail-url');
      },
      searchUrl: global.configuration.data.tpl.newsListUrl,
      resultTemplate: global.configuration.data.tpl.newsList,
    });

    // innovationsfonds filter
    $('.innovationsfonds__headlineH2').on('click', function(e) {
      $('.innovationsfonds__filter').toggleClass(
        'innovationsfonds__filter--opened'
      );
    });

    //init targetGroupFilter
    // $('.targetGroupFilter').targetGroupFilter();

    //init zoomable pictures
    $('.picture--zoomable').zoomablePicture();


    // init news teaser
    $('.newsTeaser').news({
      itemsClass: '.newsTeaser__items',
      loaderWrapperClass: '.newsTeaser__loaderWrapper',
      searchUrl: global.configuration.data.tpl.newsTeaserUrl,
      limit: 3,
      injectDataCallback: function(data) {
        data.detailUrl = this.$element.data('detail-url');
      },
      resultTemplate: global.configuration.data.tpl.newsTeaser,
    });

    // init hero teasers
    $('.heroTeaser').heroTeaser();

    //init video
    if (typeof $.fn.video === 'function') {
      $('.content .video').each(function() {
        if ($(this).closest('.stage--video').length === 0) {
          $(this).video({});
        }
      });
    }

    /*
     * init stage-video
     * @deprecated Remove when CMS implementation is finished.
     */
    if (typeof $.fn.stageVideo === 'function') {
      $('.stage--video').stageVideo();

      if (!Modernizr.objectfit && typeof $.fn.objectFit === 'function') {
        $('.stage--video .picture img').objectFit();
      }
    }

    $('.module-stage-video').moduleStageVideo();

    $('.module-content-columns').moduleContentColumns();

    // init rate widget
    $('.rateWidget').rateWidget();

    // init tariff widget
    $('.tariff-widget').tariffWidget();

    // init stickyToolbar
    $('.toolbar').stickyToolbar();

    // init toolbar selectbox - must be initialized AFTER "stickyToolbar" plugin
    $('.selectbox.toolbar__select').selectBox({
      outputSelector: '.toolbar__result',
      template: global.configuration.data.tpl.selectContatactDataOptions,
    });

    // init header - must be initialized AFTER "stickyToolbar" plugin
    $('.header').header();

    // init search
    $('.searchField').searchField();

    $('.module-dev-console').moduleDevConsole();

    // init footer selectbox
    $('.selectbox.footer__locationselect')
      .selectBox({
        onDropdownOpen: function() {
          var $dropDown = this.$dropdown;
          var dropdownToBottom =
            $(document).height() -
            ($dropDown.offset().top + $dropDown.height());
          if (dropdownToBottom < 0) {
            dropdownToBottom = Math.abs(dropdownToBottom) + 'px';
            $('.offcanvas').css('padding-bottom', dropdownToBottom);
          }
        },
        onDropdownClose: function() {
          $('.offcanvas').css('padding-bottom', '0');
        },
      })
      .on('change', function() {
        window.location.href = this.value;
      });

    // init accordion and trigger slider resize after item open
    $('.chop[data-type="accordion"]')
      .on('before.open.item.chop', function() {
        // disable smooth scroll behavior during scrolling animation of the accordion
        document.documentElement.style.scrollBehavior = 'auto';
      })
      .on('after.open.item.chop', function() {
        // init table in accordion
        var $accordionIcons = $(this).find(
          '.chop__item--active .table--responsive, .chop__item--opening .table--responsive'
        );
        $accordionIcons.each(function(index, item) {
          var $item = $(item);
          if (
            $item.closest('.accordion') &&
            !$item.closest('.table').hasClass('table--initialized')
          ) {
            $item.responsiveTables();
            $item.closest('.table').addClass('table--initialized');
          }
        });

        // reload responsive images
        $(this)
          .find('.chop__item--active .picture, .chop__item--opening .picture')
          .not('.picture--slider')
          .each(function() {
            var imagePlugin = $(this).data('plugin_responsiveImage');
            if (imagePlugin) {
              imagePlugin.loadResponsiveImage();
            }
          });
      })
      .on('after.close.item.chop', function() {
        // enable smooth scroll behavior again after scrolling animation of the accordion
        document.documentElement.style.scrollBehavior = 'smooth';
      })
      .accordion({
        init: { chop: 'accordion' },
        chop: {
          accordion: {
            onScrollAddTopOffset: function() {
              return -1 * ($('.header--sticky').height() + 15); // @TODO Fix duplicated header offset #fdho
            },
          },
        },
      });

    // propagate benefitbox links
    $('.benefitbox .cta a').propagateLink({
      subSelectors: ['.figure', '.copy', '.benefitbox__price'],
    });

    $('.benefitbox').benefitbox();

    $('.teaser .teaser__item').on('click', function(event) {
      event.preventDefault();
      var $link = $(event.currentTarget).find('.teaser__link a');
      var url = $link.attr('href');
      var target = $link.attr('target') || '_self';
      window.open(url, target);
    });

    // init SVG animations in USP box
    $('.usp__svg').each(function() {
      var duration = $(this).data('duration') || 100;
      $(this).data('vivus', new Vivus(this, { duration: duration }));
    });

    // init responsive tables
    $('.table--responsive').each(function(index, element) {
      if ($(element).closest('.accordion').length <= 0) {
        $(element).responsiveTables();
        $(element)
          .closest('.table')
          .addClass('table--initialized');
      }
    });

    /** Execute components BEFORE these lines **/

    // init show more buttons
    $('.button--showMore[data-parent]').on('click', function(e) {
      e.preventDefault();

      var $parent = $(this).closest('.' + $(this).data('parent'));
      $parent.removeClass($(this).data('parent'));

      // load responsive images
      $parent.find('.picture').each(function() {
        $(this)
          .data('plugin_responsiveImage')
          .loadResponsiveImage();
      });

      // trigger height equalizer
      $parent.trigger('recalculate.height.teaser');

      // remove click event
      $(this)
        .off('click')
        .remove();
    });

    // scroll top
    $('[data-scroll-to]').on('click', function(e) {
      e.preventDefault();
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
    });

    // init teaser equalization
    $('.teaser:not(.teaser--1col)').teaserEqualize({
      resizeEvent: 'debouncedwidth',
    });

    // init teaser equalization
    $('.targetGroupFilter ').teaserEqualize({
      resizeEvent: 'debouncedwidth',
    });

    // init teaser equalization
    $('.targetGroupFilter ').teaserEqualize({
      resizeEvent: 'debouncedwidth',
    });

    $('.iframe.component').mobileiFrame();

    // init water quality
    $('.waterQuality').waterQuality({
      resultsTemplate: global.configuration.get('tpl.waterQualitySuccess'),
    });

    // init power connection availability check
    $('.powerConnection ').powerConnection({});

    // init power connection availability check
    $('.wallbox ').wallbox({});

    $('.module-benefit-list').equalizeHeight({
      container: '.module-benefit-list .columns',
      breakpoints: {
        default: 768,
      },
    });

    $('.tabs:not(.tabs--box) .tabs-navi').each(function() {
      $(this).tabs({
        inAnimation: 'fadeIn',
        outAnimation: 'fadeOut',
        speed: 250,
        activeClass: 'current-tab',
        complete: function(element, tab) {
          var $activeTab = $(tab);
          var $nestedTeasers = $activeTab.find('.teaser:not(.teaser--1col)');

          // recalculate teaser height
          if ($nestedTeasers.length) {
            setTimeout(function() {
              $nestedTeasers.trigger('recalculate.height.teaser');
            }, 300);
          }
        },
      });
    });

    $('.tabs--box .tabs-navi').each(function() {
      $(this).tabs({
        inAnimation: 'show',
        outAnimation: 'hide',
        speed: 0,
        activeClass: 'current-tab',
        complete: function(element, tab) {
          var $activeTab = $(tab);
          var $nestedTeasers = $activeTab.find('.teaser:not(.teaser--1col)');

          // recalculate teaser height
          if ($nestedTeasers.length) {
            setTimeout(function() {
              $nestedTeasers.trigger('recalculate.height.teaser');
            }, 300);
          }
        },
      });
    });

    $('.teaser:not(.teaser--1col) .picture').on(
      'all.ready.responsiveImage',
      function() {
        // trigger height equalizer
        $(this)
          .parents('.teaser')
          .trigger('recalculate.height.teaser');
      }
    );

    $('.teaser:not(.teaser--1col) .picture').on(
      'new.source.responsiveImage',
      function() {
        // trigger height equalizer
        $(this)
          .parents('.teaser')
          .trigger('recalculate.height.teaser');
      }
    );

    $('.teaser:not(.teaser--1col) .picture').on(
      'load.source.responsiveImage',
      function() {
        // trigger height equalizer
        $(this)
          .parents('.teaser')
          .trigger('recalculate.height.teaser');
      }
    );

    // init toggle behavior for business funnel component
    $('.business-funnel__header').on('click', function() {
      $(this).toggleClass('is-open');
      $(this)
        .next()
        .toggleClass('is-hidden');
    });

    // init login state
    if (
      window.location.origin === 'https://www.badenova.de' ||
      window.location.origin === 'https://test.badenova.de'
    ) {
      var IS_TEST_SYSTEM =
        window.location.origin === 'https://test.badenova.de';
      var IS_PK =
        document.location.href.indexOf('/geschaeftskunden/') === -1
          ? true
          : false;

      var USER_STATE_REQUEST_URL_PROD = IS_PK
        ? 'https://login.badenova.de/slo/state'
        : 'https://geschaeftskunden-login.badenova.de/slo/state';
      var USER_STATE_REQUEST_URL_TEST = IS_PK
        ? 'https://login-test.badenova.de/slo/state'
        : 'https://geschaeftskunden-login-test.badenova.de/slo/state';
      var USER_STATE_REQUEST_URL = IS_TEST_SYSTEM
        ? USER_STATE_REQUEST_URL_TEST
        : USER_STATE_REQUEST_URL_PROD;

      var USER_STATE_LOGOUT_URL_PROD = 'https://login.badenova.de/logout';
      var USER_STATE_LOGOUT_URL_TEST =
        'https://staging.badenova-shop.de/logout';
      var USER_STATE_LOGOUT_URL = IS_TEST_SYSTEM
        ? USER_STATE_LOGOUT_URL_TEST
        : USER_STATE_LOGOUT_URL_PROD;

      var LOCAL_STORAGE_CHECK = IS_PK
        ? sessionStorage.getItem('bn_current_login_pk')
        : sessionStorage.getItem('bn_current_login_gk');

      if (
        LOCAL_STORAGE_CHECK === null ||
        document.referrer.indexOf(
          'https://www.badenova.de' || 'https://test.badenova.de'
        ) === -1
      ) {
        $.ajax({
          xhrFields: {
            withCredentials: true,
          },
          url: USER_STATE_REQUEST_URL,
        })
          .done(function() {
            $('.header .header__login').html(
              '<a href="' +
                USER_STATE_LOGOUT_URL +
                '" title="Logout" rel="nofollow" class="button button--green button--border icon-logout">Kundenlogout</a>'
            );
            document.querySelector('body').classList.add('signedInUser');
            sessionStorage.setItem(LOCAL_STORAGE_CHECK, true);
          })
          .fail(function() {
            sessionStorage.setItem(LOCAL_STORAGE_CHECK, false);
          });
      } else {
        if (JSON.parse(LOCAL_STORAGE_CHECK)) {
          $('.header .header__login').html(
            '<a href="' +
              USER_STATE_LOGOUT_URL +
              '" title="Logout" rel="nofollow" class="button button--green button--border icon-logout">Kundenlogout</a>'
          );
          document.querySelector('body').classList.add('signedInUser');
        }
      }
    }

    window.counterNumberGlobal = null;

    var callback = function(mutations) {
      var i = 0;

      mutations.forEach(function(mutation) {
        if (mutation.target.className === 'itc') {
          var $itcElem = $(mutation.target);
          if ($itcElem.find('#HTMLID_actionCode').length) {
            var param = $.deparam(window.location.search.replace(/^\?/, ''));
            var acHidden = $.deparam(window.location.search.replace(/^\?/, ''));

            /*jshint camelcase: false */
            param = param.ac_all;
            acHidden = acHidden.ac_hidden;
            /*jshint camelcase: true */

            if (param && param !== '') {
              param = $.removeHtml(param);
              $itcElem
                .find('#HTMLID_actionCode')
                .attr('value', param)
                .attr('readonly', 'readonly')
                .after(
                  '<input type="hidden" name="ac_hidden" value="' +
                    param +
                    '"/><input type="hidden" name="af" value="' +
                    param +
                    '"/>'
                );
              $itcElem
                .find('#HTMLID_actionCode')
                .siblings('label')
                .hide();
            }
          }
        }
        i++;
      });
    };

    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(callback);
      mo.observe(document.documentElement, {
        childList: true,
        attributes: false,
        characterData: false,
        subtree: true,
        attributeOldValue: false,
        characterDataOldValue: false,
      });
    }
  });
})(jQuery, window, document);
